import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";

import { useSelector } from "react-redux";
import { testimonialsText } from "../../i18n/testimonials";

const Testimonials = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = testimonialsText[lang];

  const scrollToContact = () => {
    const section = document.querySelector("#contact");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="py-24 bg-darkbg px-6 text-white overflow-hidden">
      {/* SECTION TITLE */}
      <motion.h2
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="text-4xl font-heading text-center text-yellow"
      >
        {t.sectionTitle}
      </motion.h2>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 mt-16">
        {t.cards.map((card, i) => (
          <motion.div
            key={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            transition={{ delay: i * 0.2 }}
            onClick={scrollToContact}
            className="
              cursor-pointer rounded-2xl bg-navy border border-gray-800 
              hover:border-gray-600 transition-all duration-300 
              p-8 shadow-lg hover:shadow-2xl
            "
          >
            {/* IMAGE */}
            <div className="w-full h-52 overflow-hidden rounded-xl">
              <img
                src={card.photo}
                alt={card.title}
                className="w-full h-full object-cover object-center grayscale"
              />
            </div>

            {/* QUOTE */}
            <p className="mt-6 text-sm uppercase tracking-wide text-yellow font-semibold">
              {card.quote}
            </p>

            {/* TITLE */}
            <h3 className="mt-2 text-2xl font-heading text-neonYellow animate-neonFlicker">
              {card.title}
            </h3>

            {/* LIST */}
            <ul className="mt-6 text-gray-300 space-y-3 leading-relaxed">
              {card.items.map((item, index) => (
                <li key={index} className="flex gap-2">
                  <span className="text-yellow mt-0">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
